import { IStockBasicDetailsResponse } from '../pages/StockDetails/types';
import httpClient from '../utils/httpClient';

const SLUG_STOCK_DETAIL_PAGE = '-share-price';

export const getStocksPriceChart = (
  cocode: string,
  exchange: string,
  period: string,
) => {
  return httpClient.get(
    `/api/v1/stocks/pricechart/${exchange}/${cocode}/${period}`,
  );
};

export const getStocksOverview = (cocode: string, exchange: string) =>
  httpClient.get(`/api/v1/stocks/${cocode}/${exchange}`);

export const getVolumeAnalysis = (cocode: string, exchange: string) =>
  httpClient.get(
    `/api/v1/stock/volume/analysis?exchange=${encodeURIComponent(exchange)}&cocode=${encodeURIComponent(cocode)}`,
  );

export const getCustomWidgets = (apiUrl: string) => {
  return httpClient.get(apiUrl);
};
export const getIndicesList = () => httpClient.get(`/api/v1/indices`);

export const getTopGainerLosers = (
  exchange: string,
  options: string,
  limit: number,
) => {
  return httpClient.get(
    `api/v1/share-market/statistics/gainerslosers/${exchange}/${options}/${limit}`,
  );
};

export const get52WeeksHighLow = (
  exchange: string,
  options: string,
  limit: number,
) => {
  return httpClient.get(
    `api/v1/share-market/statistics/52-week/${exchange}/${options}/${limit}`,
  );
};

export const getStockAbout = (cocode: string) =>
  httpClient.get(`api/v1/about/${cocode}`);

export const getStockBasicDetails = (
  companyNameWithSlug: string,
): Promise<IStockBasicDetailsResponse> => {
  const lastIndex = companyNameWithSlug.lastIndexOf(SLUG_STOCK_DETAIL_PAGE);

  const companyNameWithoutSlug =
    lastIndex !== -1
      ? companyNameWithSlug.substring(0, lastIndex)
      : companyNameWithSlug;

  return httpClient.get(`/api/v1/stocks/${companyNameWithoutSlug}`);
};

export const getStocksTechnicalChart = (cocode: string, exchange: string) => {
  return httpClient.get(`/api/v1/stocks/pivotclassic/${exchange}/${cocode}`);
};
